module.exports = __webpack_public_path__ + "img/warsztaty-filipiny-3.bff30913.jpg";